import React, { useEffect } from 'react'
import img from '../ActionPicture/img/img.svg'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import style from './ActionImageType.module.scss'

export default function ActionImageType(props) {
  const actPic = [
    { id: 0, pic: img, desc: props.translate.move_words, name: 'move' },
    { id: 1, pic: img, desc: props.translate.write_words, name: 'write' },
    { id: 2, pic: img, desc: props.translate.select_words, name: 'select' },
  ]

  useEffect(() => {
    if (!props.state) props.objectChangeHandler('move', 'subtype')
  }, [])

  return (
    <FormField>
      <FormLabel isRequired>{props.translate.choose_word_image}:</FormLabel>
      <div className={style.galeryContainer}>
        {actPic.map((item, index) => (
          <div
            key={index}
            className={`${style.block} ${item.name === props.state ? style.selected : ''}`}
            onClick={() => props.objectChangeHandler(item.name, 'subtype')}
          >
            <img src={item.pic} alt='alt' />
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </FormField>
  )
}
